<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      showFilterInputs: false,
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      SaffSel: ["Staff ID", "ST5246", "ST1269"],
      BrianSelect: ["Staff", "Brian Villalobos"],
      InSelct: ["Status", "Active", "Inactive"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <div class="page-wrapper">
      <div class="content container-fluid pb-0">
        <div
          class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
        >
          <h4>Staffs</h4>
          <div class="d-flex align-items-center">
            <span class="fs-14 me-2">Sort</span>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Newly Added
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active">Newly Added</a>
                <a href="javascript:void(0);" class="dropdown-item">Oldest</a>
              </div>
            </div>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Export
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active">Export</a>
                <a href="javascript:void(0);" class="dropdown-item">Import</a>
              </div>
            </div>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-printer"></i
            ></a>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              id="filter_search"
              @click="toggleFilterInputs"
              ><i class="ti ti-sort-descending"></i
            ></a>
            <router-link
              to="/provider/staff-grid"
              class="tags active d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-layout-grid"></i
            ></router-link>
            <router-link
              to="/provider/staff-list"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-list"></i
            ></router-link>
            <a
              href="javascript:void(0);"
              class="btn btn-dark d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#add-staff"
              ><i class="ti ti-circle-plus me-2"></i>Add Staffs</a
            >
          </div>
        </div>
        <div
          id="filter_inputs"
          v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
        >
          <div class="row">
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <div class="sel-cal Calendar-icon">
                  <span><i class="ti ti-calendar-month"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="SaffSel" id="staffsel" placeholder="Staff ID" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="BrianSelect" id="brianselect" placeholder="Staff" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="InSelct" id="inselct" placeholder="Status" />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 p-2 rounded mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-41.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-2">ST5863</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Jeff Fitch</router-link>
                    </h6>
                    <span class="fs-12">Added on : 06 Jan 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">02</h6>
                  </div>
                  <div class="border-end"></div>
                  <div class="">
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">02</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-17.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-2">ST6478</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Jacob Kline</router-link>
                    </h6>
                    <span class="fs-12">Added on : 18 Jan 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">10</h6>
                  </div>
                  <div class="border-end"></div>
                  <div class="">
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">04</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-12.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST2496</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Donald Gordon</router-link>
                    </h6>
                    <span class="fs-12">Added on : 27 Jan 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">03</h6>
                  </div>
                  <div class="border-end"></div>
                  <div class="">
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">08</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-26.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST0765</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Kara Coble</router-link>
                    </h6>
                    <span class="fs-12">Added on : 15 Feb 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">10</h6>
                  </div>
                  <div class="border-end"></div>
                  <div class="">
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">15</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-35.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST6485</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Jacob Vance</router-link>
                    </h6>
                    <span class="fs-12">Added on : 20 Feb 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">07</h6>
                  </div>
                  <div class="border-end"></div>
                  <div class="">
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">13</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-36.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST3751</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">William Smith</router-link>
                    </h6>
                    <span class="fs-12">Added on : 03 Mar 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">10</h6>
                  </div>
                  <div class="border-end"></div>
                  <div>
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">30</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-16.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST3498</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Taylor Pacheco</router-link>
                    </h6>
                    <span class="fs-12">Added on : 10 Mar 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">05</h6>
                  </div>
                  <div class="border-end"></div>
                  <div>
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">12</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-02.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST0263</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Anthony Lewis</router-link>
                    </h6>
                    <span class="fs-12">Added on : 24 Mar 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">06</h6>
                  </div>
                  <div class="border-end"></div>
                  <div>
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">10</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-24.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST3185</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Paul Steele</router-link>
                    </h6>
                    <span class="fs-12">Added on : 10 Apr 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">08</h6>
                  </div>
                  <div class="border-end"></div>
                  <div>
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">14</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-13.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST0798</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Ray Homan</router-link>
                    </h6>
                    <span class="fs-12">Added on : 17 Apr 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">06</h6>
                  </div>
                  <div class="border-end"></div>
                  <div class="">
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">15</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-06.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST4638</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Alfonso Lamotte</router-link>
                    </h6>
                    <span class="fs-12">Added on : 05 May 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">12</h6>
                  </div>
                  <div class="border-end"></div>
                  <div>
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">20</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-lg-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center bg-light-300 rounded p-2 mb-3">
                  <router-link to="/provider/staff-details" class="avatar avatar-xl me-2">
                    <img
                      src="@/assets/img/profiles/avatar-02.jpg"
                      class="rounded-circle"
                      alt="user"
                    />
                  </router-link>
                  <div>
                    <span class="badge badge-info-transparent mb-1">ST8351</span>
                    <h6 class="fs-16 fw-medium">
                      <router-link to="/provider/staff-details">Kim Crosland</router-link>
                    </h6>
                    <span class="fs-12">Added on : 19 May 2024</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="fs-14">No of Services</span>
                    <h6 class="fs-16 text-center fw-medium">08</h6>
                  </div>
                  <div class="border-end"></div>
                  <div class="">
                    <span class="fs-14 ps-1">No of Bookings</span>
                    <h6 class="fs-16 text-center fw-medium">16</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <staff-grid-modal></staff-grid-modal>
  </div>
</template>
